import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  signal,
} from '@angular/core';

@Directive({
  host: {
    '[class.focused]': '$isFocused()',
    '[class.hover-state]': '!$isFocused()',
  },
  selector: '[wcgToggleFocus]',
})
export class ToggleFocusDirective {
  private readonly _elementRef = inject(ElementRef<HTMLElement>);

  protected $isFocused = signal<boolean>(false);

  turnOffToggleFocus = input<boolean>(false); // Input to disable the toggle focus behavior
  elementClicked = output<void>();

  @HostListener('click')
  onClick(): void {
    if (!this.turnOffToggleFocus()) {
      this.$isFocused.update(() => true);
      this.elementClicked.emit();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (
      event.target &&
      !this._elementRef.nativeElement.contains(event.target)
    ) {
      this.$isFocused.update(() => false);
    }
  }
}
